import localeCodes from 'locale-codes'

function listCountries(): string[] {
  const countries = localeCodes.all
    .map(c => c.location) // Extract the location
    .filter((location): location is string => !!location) // Type guard to remove undefined
    .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
    .filter((country, index, self) => self.indexOf(country) === index) // Remove duplicates
    .filter(location => !location.includes('testing') && location !== 'UnitedStates')
  return countries
}

export default listCountries
